import React, { useEffect, useRef, useState } from 'react';

import { ITimespan, ITimespanProps } from 'components/dashboard/product-template-table/utils/interfaces';
import { convertTimeSpanToString } from 'utils/time-utils';
import './style.css';

// eslint-disable-next-line import/prefer-default-export
export function Timespan(props: ITimespanProps) {
    const timespan = props.timespan || {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    };

    const handleChangeEvent = (e: React.ChangeEvent<HTMLInputElement>, field: keyof ITimespan) => {
        const val = Number(e.target.value);
        props.changeHandler({ ...timespan, [field]: Number.isNaN(val) ? 0 : val });
    }

    const timespanValuesCount = () => Object.values(timespan).length;

    const divRef = useRef<HTMLDivElement>(null);
    const [style, setStyle] = useState({});

    const inputStyle = (inputWidth: number) => {
        return {
            width: `${inputWidth / timespanValuesCount()  }px`,
            padding: '0'
        }
    }

    useEffect(() => {
        if (divRef.current !== null) {
            const width = divRef.current.offsetWidth;
            const styles = inputStyle(width);
            setStyle(styles);
        }
    }, [props.isInEditMode])

    const inputStyle2 = {border: 'none', width: '100%', padding: '5px'};


    if (props.isInEditMode) {
        return <div ref={divRef} className='p-d-flex p-jc-between'>
            <div className="p-inputtext p-d-flex p-jc-between" style={style}>
                <input className="p-inputtext input" style={inputStyle2} value={timespan.days}
                       onChange={(e) => handleChangeEvent(e, 'days')}
                       inputMode='numeric'
                />
                <label style={{paddingBottom: '12px', paddingTop: '12px', paddingRight: '2px'}}>
                        d
                    </label>
            </div>
            <div className="p-inputtext p-d-flex p-jc-between" style={style}>
                <input className="p-inputtext input" style={inputStyle2} value={timespan.hours}
                       onChange={(e) => handleChangeEvent(e, 'hours')}
                       inputMode='numeric'
                />
                <label style={{paddingBottom: '12px', paddingTop: '12px', paddingRight: '2px'}}>
                        h
                    </label>
            </div>
            <div className="p-inputtext p-d-flex p-jc-between" style={style}>
                <input className="p-inputtext input" style={inputStyle2} value={timespan.minutes}
                       onChange={(e) => handleChangeEvent(e, 'minutes')}
                       inputMode='numeric'
                />
                <label style={{paddingBottom: '12px', paddingTop: '12px', paddingRight: '2px'}}>
                        m
                    </label>
            </div>
            <div className="p-inputtext p-d-flex p-jc-between" style={style}>
                <input className="p-inputtext input" style={inputStyle2} value={timespan.seconds}
                       onChange={(e) => handleChangeEvent(e, 'seconds')}
                       inputMode='numeric'
                />
                <label style={{paddingBottom: '12px', paddingTop: '12px', paddingRight: '2px'}}>
                        s
                    </label>
            </div>
        </div>
    } 
        return <div style={{
            width: '100%',
            border: 'none',
            maxWidth: '300px',
            backgroundColor: 'transparent',
            color: "inherit",
            whiteSpace: "nowrap"
        }} className="p-inputtext">
            {convertTimeSpanToString(timespan)}
        </div>
}